module.exports = __webpack_public_path__ + "img/TencentMeeting.8d0507ed.png";